module.exports = __webpack_public_path__ + "img/how_to_win_friends_and_people.ea161901.jpg";